import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'start',
    height: '100%',
    backgroundColor: '#EDEDF6',
    zIndex: 2,
    overflow: 'hidden'
  },
  previousTaskContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(50% - 50px)',
    maxHeight: 'calc(50% - 50px)',
    overflow: 'hidden',
    justifyContent: 'flex-end',
    width: '100%',
  },
  previousTaskScore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },
  nextTaskContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(50% - 50px)',
    maxHeight: 'calc(50% - 50px)',
    overflow: 'hidden',
    justifyContent: 'flex-start',
  },
  nextTaskScore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
  },
  activeTaskContainer: {
    maxHeight: 'calc(50% + 50px)',
    overflow: 'hidden',
    width: '100%'
  },
  emptyTaskListContainer: {
    textAlign: 'center',
  },
  padded: {
    paddingBottom: '18px',
  },
  emptyTaskListText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#3C419A',
  },
  pointer: {
    cursor: 'pointer',
  },
  contextualHelpIcon: {
    width: '50px;'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  headerName: {
    display: 'flex',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
    padding: '10px',
    margin: '0px',
    cursor: 'pointer',
  },
  sampleAssessmentScoreContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  headerScore: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#2C2D3E',
    padding: '10px',
    margin: '0px',
  },

}));
